import React from 'react';
import PropTypes from 'prop-types';
export default function FooterSocial({
  children = null
}) {
  return children && /*#__PURE__*/React.createElement("ul", {
    "aria-label": "Social networks",
    className: "footer-social list--unstyled"
  }, children);
}
FooterSocial.propTypes = {
  children: PropTypes.node
};
//# sourceMappingURL=social.js.map